import React from "react";
import DotsComponent from "../../DotsComponent";

const MiniCards = ({data}) => {
  // console.log("dfgdfg" + props[0].value)
  {console.log(data)}
  return (
    <div className="mini-card">
      {data.map((item) => (
        <div className="mini-card-solo">
          <DotsComponent />
          <div>
            <div style={{margin:'20px 12px'}}>
              <p className="mini-num">{item.value}</p>
              
            </div>
            <div className="mini-layer-2">
              <p>{item.detail}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MiniCards;
